<template>
  <v-dialog v-model="show" width="700px" persistent scrollable>
    <v-card>
      <ModelTitle title="Customer History" @close="close()" />

      <v-card-text>
        <v-skeleton-loader v-if="loading" type="list-item-three-line" />

        <div v-else>
          <div v-if="!history.length" class="text-center grey--text">
            No history recorded for this customer.
          </div>

          <v-timeline dense v-else>
            <v-timeline-item
              v-for="h in history"
              :key="h.id"
              small
              :color="colorFor(h.action)"
            >
              <div class="font-weight-medium mb-1">
                {{ h.action }} –
                <span class="primary--text">
                  {{ h.UserSnapshotName || "Unknown User" }}
                </span>
              </div>

              <div class="caption grey--text mb-2">
                {{ formatDate(h.createdAt) }}
                <div v-if="h.UserSnapshotEmail">{{ h.UserSnapshotEmail }}</div>
              </div>

              <v-alert
                border="left"
                v-if="h.changesSummary"
                outlined
                :color="colorFor(h.action)"
                :value="true"
              >
                {{ h.changesSummary }}
              </v-alert>
            </v-timeline-item>
          </v-timeline>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text color="primary" @click="close">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import customerService from "../service"; // you already have this

export default {
  props: {
    customer: Object,
    value: Boolean,
  },
  data() {
    return {
      show: this.value,
      history: [],
      loading: false,
    };
  },
  watch: {
    value(val) {
      this.show = val;
      if (val) this.triggerLoad();
    },
    show(val) {
      this.$emit("input", val);
      if (val) this.triggerLoad();
    },
    customer() {
      if (this.show) this.triggerLoad();
    },
  },
  methods: {
    close() {
      this.show = false;
    },

    triggerLoad() {
      this.$nextTick(() => {
        if (this.customer?.id) {
          this.loadHistory();
        }
      });
    },

    async loadHistory() {
      this.loading = true;
      try {
        const res = await customerService.getHistory(this.customer.id);
        this.history = res?.data || [];
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },

    formatDate(date) {
      return new Date(date).toLocaleString();
    },

    colorFor(action) {
      if (action === "CREATE") return "green";
      if (action === "UPDATE") return "blue";
      if (action === "DELETE") return "red";
      return "grey";
    },
  },
};
</script>

<style scoped>
.history-box {
  background: #f5f5f5;
  border-left: 4px solid #1976d2;
  white-space: pre-wrap;
  font-size: 13px;
}
</style>